import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import AttachFileSharpIcon from '@mui/icons-material/AttachFileSharp';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { makeStyles } from '@mui/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getDocuments } from '../../../ApiServices/Api';
import KenLoader from '../../KenLoader';
import KenDialog from '../../KenDialog';

const useStyles = makeStyles((theme) => ({
  download: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default function KenUploadButton(props) {
  const classes = useStyles();
  const { open, recordId, handleDownload, fileType, fileName } = props;
  const [loader, setLoader] = useState(false);
  const [fileBlob, setFileBlob] = useState();
  const [openPreview, setPreview] = useState(false);

  const handlPreviewModal = () => {
    setPreview(!openPreview);
  };

  const handlePreview = () => {
    setLoader(true);
    getDocuments(recordId)
      .then((res) => {
        if (res?.result?.success && res?.result?.data) {
          setFileBlob(`data:${fileType};base64,${res?.result?.data}`);
        }
        handlPreviewModal();
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  return (
    <React.Fragment>
      {loader && <KenLoader />}
      <KenDialog
        open={openPreview}
        onClose={handlPreviewModal}
        maxWidth={'200px'}
        sx={{ textAlign: 'center' }}
        title={<Typography sx={{ fontSize: 16, fontWeight: 600 }}>{fileName ? fileName : '-'}</Typography>}
      >
        {fileType?.includes('pdf') ? (
          <iframe title={fileName} src={fileBlob} style={{ width: '100%', height: '700px' }} />
        ) : (
          <img alt={fileName} src={fileBlob} style={{ width: '100%', height: '400px', objectFit: 'contain' }} />
        )}
      </KenDialog>
      {!recordId ? (
        <Button
          variant="secondary"
          onClick={open}
          startIcon={<AttachFileSharpIcon style={{ color: '#092682' }} />}
          style={{
            height: "60px",
            width: "384px",
            color: '#604797',
            border: '1px dashed #092682',
            borderRadius: 6,
            fontSize: window.innerWidth <= 768 ? '12px' : '16px',
            fontWeight: '500',
            textTransform: 'math-auto',
          }}
        >
          Choose or drag file
        </Button>
      ) : (
        <Box>
          <Grid container spacing={2} alignItems="center">
            <Grid item md={2.5}>
              <Typography
                style={{
                  color: '#ffffff',
                  fontSize: 14,
                  opacity: '0.6',
                  borderRadius: 6,
                  width: '100%',
                  background: '#008000',
                  textTransform: 'uppercase',
                  padding: '12px 0px',
                  textAlign: 'center',
                }}
              >
                Submitted
              </Typography>
            </Grid>
            <Grid item md={0.5}>
              <FileDownloadIcon
                sx={{ marginTop: '6px' }}
                className={classes.download}
                onClick={() => {
                  handleDownload(recordId, fileType, fileName);
                }}
              />
            </Grid>
            <Grid item md={0.5}>
              <VisibilityIcon
                sx={{ marginTop: '6px' }}
                className={classes.download}
                onClick={() => {
                  handlePreview();
                }}
              />
            </Grid>
            <Grid item md={8.5}>
              <Button
                variant="secondary"
                onClick={open}
                style={{
                  color: '#092682',
                  border: '1px dashed #092682',
                  borderRadius: 6,
                  width: '20%',
                }}
              >
                ReUpload
              </Button>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item md={12} textAlign="left">
              <Typography
                align="left"
                variant="subtitle2"
                sx={{
                  marginBottom: '-20px',
                  marginTop: '8px',
                  color: '#7A869A',
                }}
              >
                {fileName}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
}
